<div
  class="cbl--mode"
  [class.nuclear]="game().mode === 'nuclear'"
  [class.equity]="game().mode === 'equity'"
  [class.crazy]="game().mode === 'crazy'"
  [class.normal]="game().mode === 'normal'"
>
  @if (!uiSettings()?.hideHeader) {
    <div class="cbl--mode__header">
      {{ game().mode }} mode @if (game().fast) {
      <svg-icon
        class="cbl--mode__header-fast flex items-center justify-center s-18"
        src="assets/icons/case-battles/fast.svg"
      ></svg-icon>
      } @if (game().private) {
      <svg-icon
        class="cbl--mode__header-private flex items-center justify-center s-18"
        src="assets/icons/ui/lock.svg"
      ></svg-icon>
      }
    </div>
  }
  <div class="cbl--mode__players">
    @for (player of playersArray(); track index; let last = $last; let index =
    $index) {
    <!--  -->
    @if (player !== null) {
    <div
      @fadeInOutAnimation
      [class.bot]="player.is_bot"
      (click)="
        player.is_bot ? null : contextMenuService.open($event, { user: player })
      "
      [class.lose]="
        animation()
          ? (animation() === 'battle-results' || animation() === 'finished') &&
            !winnerSlots().includes(player.slot)
          : game().status === 'finished' && !winnerSlots().includes(player.slot)
      "
      [class.winner]="
        animation() !== null
          ? (animation() === 'battle-results' || animation() === 'finished') &&
            winnerSlots().includes(player.slot)
          : game().status === 'finished' && winnerSlots().includes(player.slot)
      "
      class="cbl--mode__avatar"
      [ngpTooltipTrigger]="tooltip"
      [ngpTooltipTriggerHideDelay]="0"
    >
      <img
        class="cbl--mode__avatar-picture"
        [src]="player.avatar"
        [alt]="player.name"
      />
      @if (animation() !== null ? (animation() === 'battle-results' ||
      animation() === 'finished') && winnerSlots().includes(player.slot) :
      game().status === 'finished' && winnerSlots().includes(player.slot)) {
      <img
        class="cbl--mode__crown"
        @fadeInOutAnimation
        src="assets/images/king/crown.png"
      />
      }
    </div>
    <ng-template #tooltip>
      <div ngpTooltip class="tooltip flex flex-col padding-8">
        <app-player-row [player]="player"></app-player-row>
      </div>
    </ng-template>
    } @else {
    <div class="cbl--mode__placeholder">?</div>

    }
    <!--  -->
    @if ((game().type !== 'team' && !last) || (game().type === 'team' && index
    === 1)) {
    <app-cb-icon
      class="cbl--mode__icon"
      size="16px"
      [variant]="game().mode"
    ></app-cb-icon>
    } }
  </div>
</div>
